/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestedOrgInviteReason = "AttendSameMeetings" | "MeetsWithYourTeammates" | "OnYourTeam" | "OrganizedYourMeetings" | "%future added value";
export type SuggestedOrgInviteResolution = "Accepted" | "Dismissed" | "%future added value";
export type OrgInvite_org = {
    readonly id: string;
    readonly personCorpusErrorable: {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        readonly __typename: "PersonList";
        readonly list: ReadonlyArray<{
            readonly primaryEmail: string;
            readonly emails: ReadonlyArray<string>;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly externalImageUrl: string | null;
            } | null;
            readonly isYou: boolean;
            readonly isUser: boolean;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly suggestedInvites: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly targetCalendarId: string | null;
                readonly targetProfile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
                readonly resolution: SuggestedOrgInviteResolution | null;
                readonly numberOfSharedMeetings: number | null;
                readonly numberOfOrganizedMeetings: number | null;
                readonly inviteReason: SuggestedOrgInviteReason | null;
                readonly totalScore: number | null;
            } | null;
        } | null> | null;
    } | null;
    readonly pendingInvites: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly targetCalendarId: string | null;
                readonly lastSentTime: number | null;
                readonly targetProfile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"InviteCard_org" | "CopyPersonalInviteLinkBtn_org">;
    readonly " $refType": "OrgInvite_org";
};
export type OrgInvite_org$data = OrgInvite_org;
export type OrgInvite_org$key = {
    readonly " $data"?: OrgInvite_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OrgInvite_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "givenName",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "familyName",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalImageUrl",
            "storageKey": null
        } as any
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetCalendarId",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "targetProfile",
        "plural": false,
        "selections": (v1 /*: any*/),
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "OrgInvite_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "personCorpusErrorable",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                            }
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Person",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "primaryEmail",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emails",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UserProfile",
                                        "kind": "LinkedField",
                                        "name": "profile",
                                        "plural": false,
                                        "selections": (v1 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isYou",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isUser",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "PersonList",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": (v2 /*: any*/),
                "concreteType": "SuggestedOrgInviteConnection",
                "kind": "LinkedField",
                "name": "suggestedInvites",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SuggestedOrgInviteEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SuggestedOrgInvite",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v3 /*: any*/),
                                    (v4 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "resolution",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "numberOfSharedMeetings",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "numberOfOrganizedMeetings",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "inviteReason",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "totalScore",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": "suggestedInvites(first:1000000)"
            },
            {
                "alias": null,
                "args": (v2 /*: any*/),
                "concreteType": "OrgInviteConnection",
                "kind": "LinkedField",
                "name": "pendingInvites",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrgInviteEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgInvite",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v3 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "lastSentTime",
                                        "storageKey": null
                                    },
                                    (v4 /*: any*/)
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": "pendingInvites(first:1000000)"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InviteCard_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CopyPersonalInviteLinkBtn_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '7d60a4c0dd2225e0432508570979bd65';
export default node;
